import React from 'react';

const HtmlComponent = ({ htmlContent }) => {
  return <div style={{ width:800, }} dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default HtmlComponent;
